// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const EndpointCandidateVerificationStatusSchema = z.enum(['PENDING','VERIFIED','FAILED','REJECTED','SKIPPED','REACHABLE'] as const);

export type EndpointCandidateVerificationStatusType = `${z.infer<typeof EndpointCandidateVerificationStatusSchema>}`

export default EndpointCandidateVerificationStatusSchema;
